<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-title>
            E-Mail Benachrichtigungen
          </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="order_inform"
            dense
            :rules="[emailListRule]"
            label="E-Mail-Adressen die bei Bestellungen informiert werden sollen (Semikolon ; getrennt)"
            persistent-hint
            hint="Doppelte E-Mail-Adressen sind nicht erlaubt. Jede E-Mail-Adresse muss gültig sein."
            :append-icon="isOrderValid && order_inform != $store.state.general.settings.shop_gbs_order_inform ? 'mdi-content-save-all' : ''"
            @click:append="save_order_inform()"
          ></v-text-field>
          <v-text-field
            v-model="cancel_inform"
            class="mt-5"
            dense
            :rules="[emailListRule]"
            label="E-Mail-Adressen die bei der Ablehnung von Bestellungen informiert werden sollen (Semikolon ; getrennt)"
            persistent-hint
            hint="Doppelte E-Mail-Adressen sind nicht erlaubt. Jede E-Mail-Adresse muss gültig sein."
            :append-icon="isCancelValid && cancel_inform != $store.state.general.settings.shop_gbs_cancel_inform ? 'mdi-content-save-all' : ''"
            @click:append="save_cancel_inform()"
          ></v-text-field>
        </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
      >
        <v-alert dense type="info">
          Der Benutzer erhält derzeit ausschließlich bei einer Bestellung eine Bestellbestätigung.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "ShopManage",
  data() {
    return {
      order_inform: "",
      cancel_inform: "",
    };
  },
  methods: {
    save_order_inform() {
      this.$store.dispatch("update", {  payload_type: "PUT", context: "/settings/shop_gbs_order_inform", payload: { new_value: this.order_inform } });
    },
    save_cancel_inform() {
      this.$store.dispatch("update", {  payload_type: "PUT", context: "/settings/shop_gbs_cancel_inform", payload: { new_value: this.cancel_inform } });
    }
  },
  computed: {
    isOrderValid() {
      return this.emailListRule(this.order_inform) === true;
    },
    isCancelValid() {
      return this.emailListRule(this.cancel_inform) === true;
    },
    emailListRule() {
      return value => {
        if (!value) return true; // leer erlauben, falls optional

        if (/\s/.test(value)) {
          return "Leerzeichen sind nicht erlaubt";
        }

        const emails = value
          .split(";")
          .map(e => e.trim())
          .filter(e => e.length > 0);

        const emailRegex =
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const unique = new Set(emails);
        if (unique.size !== emails.length) {
          return "Doppelte E-Mail-Adressen sind nicht erlaubt";
        }

        const invalid = emails.find(e => !emailRegex.test(e));

        return invalid
          ? `Ungültige E-Mail-Adresse: ${invalid}`
          : true;
      };
    }
  },
  created() {
    this.$watch(
      () => this.$store.state.general.settings.shop_gbs_order_inform,
      (newVal) => {
        if (newVal === undefined) return;
        this.order_inform = newVal || "";
      },
      { immediate: true }
    );

    this.$watch(
      () => this.$store.state.general.settings.shop_gbs_cancel_inform,
      (newVal) => {
        if (newVal === undefined) return;
        this.cancel_inform = newVal || "";
      },
      { immediate: true }
    );
  },
  mounted() {
    this.$store.dispatch("update", { context: "/settings/shop_gbs_order_inform" });
    this.$store.dispatch("update", { context: "/settings/shop_gbs_cancel_inform" });
  }
};

</script>


<style scoped>

</style>